export default __webpack_public_path__ + "static/media/AngelApe.d0606b01.png";